// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2QNs9","cell":"ColumnAccessor_cell__3gz2B","firstCellAccent":"ColumnAccessor_firstCellAccent__9Ow6v"};